import * as React from 'react';
import { signOut } from 'web/web-helpers/authentication-helper-web';
import { Spinner } from '../../components/spinner/spinner';

export default class LogoutRedirectPage extends React.PureComponent<{}, {}> {
	constructor(props: any) {
		super(props);
		this.state = {};

		this.signOut();
	}

	public render() {
		return <Spinner />;
	}

	private signOut() {
		signOut();
	}
}
